<template>
  <v-dialog v-model="dialog" width="800" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on }">
      <p class="overline primary--text" v-on="on">
        * {{ students.length }} học sinh được chọn
        <v-icon color="primary">
          mdi-eye
        </v-icon>
      </p>
    </template>

    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >Danh sách học sinh
        <v-spacer />
        <v-icon color="white" @click.stop="dialog = false">close</v-icon>
      </v-card-title>
      <v-card-text>
        <p class="overline mt-2">* {{ students.length }} học sinh được chọn</p>
        <v-data-table
          item-key="id"
          :headers="headers"
          :items="students"
          :items-per-page="10"
          dense
        >
          <template v-slot:item.index="{ item }">
            <span>{{ students.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:item.name="{ item }">
            <span>{{ item.name }}</span>
          </template>
          <template v-slot:item.generation="{ item }">
            <span style="white-space: nowrap;">{{
              item.generation ? item.generation.code : ''
            }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    students: Array
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'STT', value: 'index', align: 'left', sortable: false },
        { text: 'Tên', value: 'name', align: 'left', sortable: false },
        { text: 'Khóa', value: 'generation', align: 'left', sortable: false },
        { text: 'Nhóm', value: 'tags', align: 'left', sortable: false },
        { text: 'Email', value: 'email', align: 'left', sortable: false },
        {
          text: 'Số Điện Thoại',
          value: 'phone',
          align: 'left',
          sortable: false
        },
        { text: 'Giới tính', value: 'gender', align: 'left', sortable: false }
      ]
    }
  }
}
</script>
